import type { PointerEvent } from "react";

/**
 * Wrap a hover-enter handler so only a real mouse triggers it.
 *
 * iPad fires `mouseenter` on every tap and never fires the matching
 * `mouseleave` until the next tap somewhere else, so JS hover state set from
 * `onMouseEnter` sticks on touch exactly like an unguarded CSS `:hover` (see
 * the HOVER RULE in `global.css`). Use `onPointerEnter={mouseOnly(fn)}`
 * instead; the leave handler can stay as it is.
 */
export function mouseOnly<E extends Element>(fn: (e: PointerEvent<E>) => void) {
  return (e: PointerEvent<E>) => {
    if (e.pointerType === "mouse") fn(e);
  };
}
